<script>
export default {
    props: {
        strings: {
            type: Array,
            required: true,
            default: () => []
        },
        numbers: {
            type: Number,
            required: false,
            default: () => 4
        },
    },
    setup() {

    }
}
</script>

<template>
    <div class="d-flex align-center gap-2 flex-wrap">
        <w-chip
            v-for="(str, index) in strings.slice(0, numbers)"
            :key="`str-${str}-${index}`"
            outlined
            :text="str"
        />

        <!-- Badge showing remaining count -->
        <v-badge
            v-if="strings.length > numbers"
            :content="strings.length - numbers"
            bordered
            overlap
            color="red"
        >
            <v-chip
                outlined
                small
                color="red"
            >
                <strong>+{{ $t('common.more') }}</strong>
            </v-chip>
        </v-badge>
    </div>
</template>

<style scoped>

</style>